import AppError from './AppError';

export default class StorageLimitError extends AppError {
	constructor() {
		super( { name: 'StorageLimitError' } );
	}
}
